module.exports = __webpack_public_path__ + "img/480-5d4a0c.png";